<template>
	<div>
		<div id="modal_popup_confirmOrderPay" class="modal-popup">
			<div class="modal-popup-content">
				<a
					@click="showModalPopup('modal_popup_confirmOrderPay', false)"
					class="close-button"
				>
					<img src="@/assets/images/close-button.svg" />
				</a>
				<div class="iris_logo">
					<img src="@/assets/images/logo_iris.png" style="width:20%;" />
				</div>
				<p v-if="order">
					{{ $t("confirmOrderInfo") }}
				</p>
				<p v-if="order">
					{{ $t("confirmOrderPay") }}
					{{ order.total_amount_value | toCurrency }}
					{{ $t("confirmOrderPay2") }}
				</p>
				<div class="buttons">
					<a href="#" class="yesButton" @click="payOrder()">
						{{ $t("notificationsChooseOptionYes") }}
					</a>
					<a
						href="#"
						class="noButton"
						@click="showModalPopup('modal_popup_confirmOrderPay', false)"
						>{{ $t("notificationsChooseOptionNo") }}</a
					>
				</div>
			</div>
		</div>
		<div id="modal_popup_error" class="modal-popup">
			<div class="modal-popup-content">
				<a
					@click="showModalPopup('modal_popup_error', false)"
					class="close-button"
				>
					<img src="@/assets/images/close-button.svg" />
				</a>
				<p
					v-if="this.orderError"
					v-html="$t('orderError_' + this.orderError.code)"
				></p>
				<p v-else v-html="$t('orderPayRedirect')"></p>
				<!-- <p v-if="this.newOrder.successLink && this.orderStep === 4" v-html="$t('actionUploadFileSuccess')"></p> -->
			</div>
		</div>
	</div>
</template>

<script>
import httpServiceCustomer from "@/http/http-customer.js";
import Cookies from "js-cookie";

export default {
	components: {},
	props: {
		order: Object,
		customerId: Number,
	},
	data() {
		return {
			orderError: null,
		};
	},
	methods: {
		payOrder() {
			this.showModalPopup("modal_popup_loading", true);
			// pay order
			let payload = {
				instructedAmount: this.order.total_amount_value * 100,
				remmittanceInfo: {unstructured1: this.order.id},
			};
			this.showModalPopup("modal_popup_confirmOrderPay", false);
			httpServiceCustomer.customerService
				.payOrder(this.customerId, payload, Cookies.get("token"))
				.then(function(response) {
					// handle success
					return response;
				})
				.catch(function(response) {
					// handle success
					return response.response;
				})
				.then((response) => {
					if (response.status === 200) {
						if (response.data.resp) {
							window.open(response.data.resp.bankSelectionToolUrl, "_blank");
						} else {
							this.orderError = {
								code: "PAYMENT",
								description: "Error paying order",
							};
						}
					} else if (response.status === 400 || response.status === 403) {
						this.orderError = {
							code: response.data.error_code,
							description: "Error paying order",
						};
						// return null;
					} else {
						this.orderError = {
							code: "PAYMENT",
							description: "Error paying order",
						};
						// return null;
					}
					this.showModalPopup("modal_popup_loading", false);
					this.showModalPopup("modal_popup_error", true);
				});
		},
		showModalPopup(elementId, show) {
			if (show) {
				document.getElementById(elementId).style.visibility = "visible";
			} else {
				document.getElementById(elementId).style.visibility = "hidden";
			}
		},
	},
};
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
